import script from "./HTMoleGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HTMoleGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./HTMoleGamePlay.vue?vue&type=style&index=0&id=7d8479b7&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8479b7"]])

export default __exports__